import {
  OR_CLOSE_PAYMENT_MODAL,
  OR_SET_PAYMENT_STATUS,
  OR_REQUEST_INIT_PAYMENT_DATA,
  OR_RECEIVE_INIT_PAYMENT_DATA,
  OR_RECEIVE_INIT_PAYMENT_DATA_ERROR,
  OR_REQUEST_FINISH_REGISTRATION,
  OR_RECEIVE_FINISH_REGISTRATION,
  OR_RECEIVE_FINISH_REGISTRATION_ERROR,
  OR_STATUS_PENDING,
  OR_STATUS_ERROR,
  OR_STATUS_SUCCESS,
} from '../../actions/registration/finishRegistration';
import { OR_REGISTRATION_RESET_DATA } from '../../actions/registration/ordersReservedRegistration';

export const initialState = {
  paymentUrl: '',
  modalVisible: false,
  isFetchingInitPayment: false,
  paymentStatus: OR_STATUS_PENDING,
  finishRegistrationStatus: OR_STATUS_PENDING,
  orders: [],
  nextActualOrderSlot: null,
  deliveryDay: '',
  frequency: '',
};

export default function finishRegistrationDataReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_INIT_PAYMENT_DATA:
      return {
        ...state,
        finishRegistrationStatus: OR_STATUS_PENDING,
        isFetchingInitPayment: true,
        modalVisible: false,
        paymentStatus: OR_STATUS_PENDING,
        paymentUrl: '',
      };
    case OR_RECEIVE_INIT_PAYMENT_DATA:
      return {
        ...state,
        isFetchingInitPayment: false,
        modalVisible: true,
        paymentUrl: `/webshop${action.data.paymentUrl}`,
      };
    case OR_RECEIVE_INIT_PAYMENT_DATA_ERROR:
      return {
        ...state,
        isFetchingInitPayment: false,
        modalVisible: true,
        paymentStatus: OR_STATUS_ERROR,
      };
    case OR_CLOSE_PAYMENT_MODAL:
      return initialState;
    case OR_SET_PAYMENT_STATUS:
      return { ...state, paymentStatus: action.status };
    case OR_REQUEST_FINISH_REGISTRATION:
      return { ...state, finishRegistrationStatus: OR_STATUS_PENDING };
    case OR_RECEIVE_FINISH_REGISTRATION:
      return {
        ...state,
        deliveryDay: action.data.deliveryDay,
        finishRegistrationStatus: OR_STATUS_SUCCESS,
        frequency: action.data.frequency,
        nextActualOrderSlot: action.data.nextActualOrderSlot,
        orders: action.data.orders,
      };
    case OR_RECEIVE_FINISH_REGISTRATION_ERROR:
      return { ...state, finishRegistrationStatus: OR_STATUS_ERROR };
    case OR_REGISTRATION_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
